module.exports = __webpack_public_path__ + "img/shopNum1.5a4b96cf.png";